import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text, useTheme } from '@rneui/themed';
import dayjs from 'dayjs';
import { StdUnitStepper } from './StdUnitStepper';
import { IconBeerII, IconBeerIII, IconWine, IconSpirit } from './stduniticons';

export const StdUnitsInput = ({
  addConsumption,
  consumptionGoal,
  consumptionTodayByUnit,
  date,
  totalConsumption,
}) => {
  const { theme } = useTheme();

  const add = async (unitId, amount) => {
    const datetime = (date ? dayjs(date) : dayjs()).format(
      'YYYY-MM-DDTHH:mm:ss'
    );
    await addConsumption({
      unitId,
      amount,
      datetime,
      registeredAt: datetime,
      location: null,
      confirmed: true,
    });
  };

  const renderIcon = (unitId, active) => {
    switch (unitId) {
      case 1:
        return <IconBeerII active={active} />;
      case 2:
        return <IconBeerIII active={active} />;
      case 3:
        return <IconWine active={active} />;
      case 5:
        return <IconSpirit active={active} />;
    }
  };

  const unitActive = (unitId) => {
    return unitTotal(unitId) > 0;
  };

  const unitTotal = (unitId) => {
    return consumptionTodayByUnit[unitId]?.total || 0;
  };

  const overDayLimit = useMemo(
    () => totalConsumption?.today > consumptionGoal?.stdUnitDay,
    [totalConsumption?.today, consumptionGoal?.stdUnitDay]
  );
  const overWeekLimit = useMemo(
    () => totalConsumption?.week > consumptionGoal?.stdUnitWeek,
    [totalConsumption?.week, consumptionGoal?.stdUnitWeek]
  );

  return (
    <View>
      {(overDayLimit || overWeekLimit) && (
        <Text style={{ color: theme.colors.secondary, marginBottom: 20 }}>
          Nu är du över din gräns för {overDayLimit ? 'dag' : 'vecka'}
        </Text>
      )}
      <View style={styles.stepperView}>
        <StdUnitStepper
          icon={renderIcon(1, unitActive(1))}
          value={unitTotal(1)}
          add={(amount) => add(1, amount)}
          overDayLimit={overDayLimit}
        />
        <StdUnitStepper
          icon={renderIcon(2, unitActive(2))}
          value={unitTotal(2)}
          add={(amount) => add(2, amount)}
          overDayLimit={overDayLimit}
        />
        <StdUnitStepper
          icon={renderIcon(3, unitActive(3))}
          value={unitTotal(3)}
          add={(amount) => add(3, amount)}
          overDayLimit={overDayLimit}
        />
        <StdUnitStepper
          icon={renderIcon(5, unitActive(5))}
          value={unitTotal(5)}
          add={(amount) => add(5, amount)}
          overDayLimit={overDayLimit}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  stepperView: {
    flexDirection: 'row',
  },
});
